import React, { useState } from "react";

// --- Inline SVG Icons (Strictly typed for TSX) ---
const CheckCircle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);
const Calendar = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);
const ArrowRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);
const Star = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);
const Activity = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
  </svg>
);
const Clock = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);
const TrendingDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polyline points="23 18 13.5 8.5 8.5 13.5 1 6" />
    <polyline points="17 18 23 18 23 12" />
  </svg>
);
const Menu = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);
const X = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
const PlayCircle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="12" cy="12" r="10" />
    <polygon points="10 8 16 12 10 16 10 8" />
  </svg>
);
const Dumbbell = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M14.4 14.4 9.6 9.6" />
    <path d="M18.65 21.35a2 2 0 0 1-2.83 0l-5.66-5.66a2 2 0 0 1 0-2.83l.06-.06a2 2 0 0 1 2.83 0l5.66 5.66a2 2 0 0 1 0 2.83Z" />
    <path d="M2.65 5.35a2 2 0 0 1 2.83 0l5.66 5.66a2 2 0 0 1 0 2.83l-.06.06a2 2 0 0 1-2.83 0L2.65 8.18a2 2 0 0 1 0-2.83Z" />
  </svg>
);
const ChevronLeft = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polyline points="15 18 9 12 15 6" />
  </svg>
);
const ChevronRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
);
const Plus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);
const Minus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);
// ----------------------------------------------------------------------------------

export default function App() {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const [openFaq, setOpenFaq] = useState<number>(-1);

  const testimonials = [
    {
      id: 1,
      name: "David O.",
      role: "Software Engineer",
      metricLabel: "Weight Lost",
      metricValue: "18.5 kg",
      badge: "-18kg in 12 Weeks",
      image: "https://i.ibb.co/C5JWSNhD/davido-image-1.jpg",
      quote:
        "As a tech executive, my schedule was brutal. Tunde didn't just give me a workout; he completely restructured how I approach fitness and nutrition. This is the only program I've ever stuck to.",
    },
    {
      id: 2,
      name: "Michael A.",
      role: "Bank Manager",
      metricLabel: "Muscle Gained",
      metricValue: "8.2 kg",
      badge: "+8kg Lean Muscle",
      image: "https://i.ibb.co/B2BDsJSp/michael-image-1.jpg",
      quote:
        "I wanted to build muscle but was tired of generic gym routines. Tunde's muscle gain protocol was incredibly detailed. I look better in suits, and my energy levels have skyrocketed.",
    },
    {
      id: 3,
      name: "Emeka U.",
      role: "Startup Founder",
      metricLabel: "Body Fat",
      metricValue: "-12%",
      badge: "Shredded & Energized",
      image: "https://i.ibb.co/FLKGqVkB/emeka-image-1.jpg",
      quote:
        "The accountability is unmatched. I travel frequently, but Tunde's system adapts to my hotel gyms. I'm leaner than I was in my 20s and my mental clarity is at an all-time high.",
    },
  ];

  const faqs = [
    {
      q: "I have a busy schedule. Will this work for me?",
      a: "Absolutely. This system is specifically designed for busy professionals. We focus on efficient 45-minute workouts 3-4 times a week and nutrition plans that don't require hours of meal prep.",
    },
    {
      q: "Do I need a gym membership?",
      a: "While a gym membership is recommended for the fastest results, I create custom home-workout protocols using minimal equipment if you prefer training at home or travel frequently.",
    },
    {
      q: "Why is the consultation paid?",
      a: "The ₦15,000 fee acts as a filter. I only work with highly committed individuals. During the call, you get actual actionable strategies whether you sign up for the full program or not.",
    },
    {
      q: "Are meal plans included?",
      a: "Yes. I don't just tell you to 'eat less'. You get a structured, realistic nutrition protocol tailored to Nigerian/Continental foods you actually enjoy, optimized for your macros.",
    },
  ];

  const nextSlide = () =>
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  const prevSlide = () =>
    setCurrentSlide(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );

  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-50 font-sans selection:bg-amber-500 selection:text-black">
      {/* Navigation */}
      <nav className="fixed w-full z-50 bg-zinc-950/90 backdrop-blur-md border-b border-zinc-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center gap-2">
              <Dumbbell className="h-8 w-8 text-amber-500" />
              <span className="font-bold text-2xl tracking-tighter uppercase">
                Coach Tunde
              </span>
            </div>

            {/* Desktop Nav */}
            <div className="hidden md:flex items-center space-x-8">
              <a
                href="#programs"
                className="text-sm font-medium hover:text-amber-400 transition-colors"
              >
                Programs
              </a>
              <a
                href="#results"
                className="text-sm font-medium hover:text-amber-400 transition-colors"
              >
                Results
              </a>
              <a
                href="#story"
                className="text-sm font-medium hover:text-amber-400 transition-colors"
              >
                My Story
              </a>
              <a
                href="#booking"
                className="bg-amber-500 text-black px-6 py-2.5 rounded-full font-bold hover:bg-amber-400 transition-all transform hover:scale-105"
              >
                Book Consultation
              </a>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden flex items-center">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-zinc-300 hover:text-white"
              >
                {isMenuOpen ? (
                  <X className="h-6 w-6" />
                ) : (
                  <Menu className="h-6 w-6" />
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Nav */}
        {isMenuOpen && (
          <div className="md:hidden bg-zinc-900 border-b border-zinc-800 pb-4 px-4 space-y-4">
            <a
              href="#programs"
              onClick={() => setIsMenuOpen(false)}
              className="block text-base font-medium py-2"
            >
              Programs
            </a>
            <a
              href="#results"
              onClick={() => setIsMenuOpen(false)}
              className="block text-base font-medium py-2"
            >
              Results
            </a>
            <a
              href="#story"
              onClick={() => setIsMenuOpen(false)}
              className="block text-base font-medium py-2"
            >
              My Story
            </a>
            <a
              href="#booking"
              onClick={() => setIsMenuOpen(false)}
              className="block text-center bg-amber-500 text-black px-6 py-3 rounded-md font-bold mt-4"
            >
              Book Consultation
            </a>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?q=80&w=2070&auto=format&fit=crop"
            alt="Coach Tunde Training"
            className="w-full h-full object-cover object-center opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-zinc-950 via-zinc-950/90 to-transparent"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-transparent to-transparent"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-zinc-900 border border-zinc-700 mb-6">
              <span className="flex h-2 w-2 rounded-full bg-amber-500 animate-pulse"></span>
              <span className="text-xs font-semibold uppercase tracking-wider text-zinc-300">
                Accepting 5 New Clients This Month
              </span>
            </div>
            <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight mb-6 leading-tight">
              Helping Busy Professionals Lose{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600">
                10–20kg in 90 Days.
              </span>
            </h1>
            <p className="text-lg md:text-xl text-zinc-400 mb-10 max-w-xl leading-relaxed">
              Stop guessing with random workouts. Get a structured, premium
              coaching system designed for high-performers who demand real,
              sustainable results.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="#booking"
                className="inline-flex justify-center items-center gap-2 bg-amber-500 text-black px-8 py-4 rounded-full font-bold text-lg hover:bg-amber-400 transition-all transform hover:-translate-y-1"
              >
                Start Your Transformation <ArrowRight className="h-5 w-5" />
              </a>
              <a
                href="#results"
                className="inline-flex justify-center items-center gap-2 bg-zinc-800 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-zinc-700 transition-all"
              >
                <PlayCircle className="h-5 w-5" /> See Client Results
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Results Dashboard (Social Proof) */}
      <section
        id="results"
        className="py-20 bg-zinc-950 relative border-t border-zinc-900"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              The Results Dashboard
            </h2>
            <p className="text-zinc-400 max-w-2xl mx-auto">
              Real metrics from busy professionals just like you who committed
              to the 90-day process.
            </p>
          </div>

          {/* Metrics Row */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 mb-16">
            {[
              {
                label: "Total Weight Lost",
                value: "1,250+",
                unit: "kg",
                icon: <TrendingDown className="h-6 w-6 text-amber-500" />,
              },
              {
                label: "Avg. Time Taken",
                value: "90",
                unit: "Days",
                icon: <Clock className="h-6 w-6 text-amber-500" />,
              },
              {
                label: "Success Rate",
                value: "98",
                unit: "%",
                icon: <Activity className="h-6 w-6 text-amber-500" />,
              },
              {
                label: "5-Star Reviews",
                value: "100",
                unit: "+",
                icon: <Star className="h-6 w-6 text-amber-500" />,
              },
            ].map((stat, idx) => (
              <div
                key={idx}
                className="bg-zinc-900 p-6 rounded-2xl border border-zinc-800 flex flex-col items-center justify-center text-center"
              >
                <div className="bg-black p-3 rounded-full mb-4">
                  {stat.icon}
                </div>
                <div className="flex items-baseline gap-1">
                  <span className="text-4xl font-bold">{stat.value}</span>
                  <span className="text-amber-500 font-semibold">
                    {stat.unit}
                  </span>
                </div>
                <span className="text-sm text-zinc-400 mt-2">{stat.label}</span>
              </div>
            ))}
          </div>

          {/* Featured Proof of Work Strip */}
          <div className="border-y border-zinc-800/50 py-10 mb-16 bg-zinc-950/50 text-center">
            <p className="text-sm font-semibold text-zinc-500 uppercase tracking-widest mb-8">
              Trusted by Professionals From
            </p>
            <div className="flex flex-wrap justify-center items-center gap-10 md:gap-20 opacity-60 grayscale">
              <span className="text-2xl font-black font-serif">KPMG</span>
              <span className="text-2xl font-black font-sans">MTN</span>
              <span className="text-2xl font-black font-serif tracking-tighter">
                PwC
              </span>
              <span className="text-xl font-black tracking-widest">ACCESS</span>
              <span className="text-2xl font-black font-sans italic">
                Chevron
              </span>
            </div>
          </div>

          {/* Transformation Carousel */}
          <div className="relative max-w-5xl mx-auto">
            <div className="overflow-hidden rounded-3xl border border-zinc-800 bg-zinc-900 relative shadow-2xl shadow-black/50">
              <div
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {testimonials.map((testimonial) => (
                  <div
                    key={testimonial.id}
                    className="min-w-full flex flex-col md:flex-row"
                  >
                    <div className="relative h-72 md:h-auto md:w-2/5 bg-zinc-800 shrink-0">
                      <img
                        src={testimonial.image}
                        alt="Transformation Before/After"
                        className="w-full h-full object-cover opacity-80"
                      />
                      <div className="absolute top-6 left-6 bg-black/80 backdrop-blur px-4 py-2 rounded-lg text-sm font-bold text-amber-400 border border-zinc-700/50">
                        {testimonial.badge}
                      </div>
                    </div>
                    <div className="p-8 md:p-12 md:w-3/5 flex flex-col justify-center bg-gradient-to-br from-zinc-900 to-zinc-950">
                      <div className="flex text-amber-500 mb-6">
                        {[...Array(5)].map((_, i) => (
                          <Star key={i} className="h-5 w-5 fill-current" />
                        ))}
                      </div>
                      <p className="text-lg md:text-xl italic text-zinc-300 mb-8 leading-relaxed">
                        "{testimonial.quote}"
                      </p>
                      <div className="flex justify-between items-end border-t border-zinc-800 pt-6 mt-auto">
                        <div>
                          <h4 className="font-bold text-white text-lg">
                            {testimonial.name}
                          </h4>
                          <span className="text-sm text-amber-500/80">
                            {testimonial.role}
                          </span>
                        </div>
                        <div className="text-right">
                          <div className="text-sm text-zinc-400 mb-1">
                            {testimonial.metricLabel}
                          </div>
                          <div className="font-bold text-amber-500 text-2xl">
                            {testimonial.metricValue}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Carousel Controls */}
            <div className="flex justify-center items-center gap-6 mt-10">
              <button
                onClick={prevSlide}
                className="p-3 rounded-full bg-zinc-900 border border-zinc-800 hover:bg-amber-500 hover:text-black hover:border-amber-500 transition-all shadow-lg text-zinc-400"
              >
                <ChevronLeft className="h-6 w-6" />
              </button>
              <div className="flex gap-3">
                {testimonials.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => setCurrentSlide(idx)}
                    className={`h-2.5 rounded-full transition-all duration-300 ${
                      currentSlide === idx
                        ? "w-10 bg-amber-500"
                        : "w-2.5 bg-zinc-700 hover:bg-zinc-600"
                    }`}
                  />
                ))}
              </div>
              <button
                onClick={nextSlide}
                className="p-3 rounded-full bg-zinc-900 border border-zinc-800 hover:bg-amber-500 hover:text-black hover:border-amber-500 transition-all shadow-lg text-zinc-400"
              >
                <ChevronRight className="h-6 w-6" />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* "Who Is This For" Section */}
      <section className="py-24 bg-zinc-900/50 border-t border-zinc-900 relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-bold mb-4">
              Is This For You?
            </h2>
            <p className="text-zinc-400 max-w-2xl mx-auto text-lg">
              My systems are highly effective, but they are not for everyone. I
              strictly filter my clients.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 md:gap-12">
            <div className="bg-zinc-950 p-8 md:p-10 rounded-3xl border border-red-900/30 shadow-lg">
              <div className="flex items-center gap-4 mb-8">
                <div className="bg-red-500/10 p-3 rounded-full text-red-500">
                  <X className="h-6 w-6 md:h-8 md:w-8" />
                </div>
                <h3 className="text-2xl md:text-3xl font-bold">
                  Who This is NOT For
                </h3>
              </div>
              <ul className="space-y-6 text-zinc-400 text-lg">
                <li className="flex gap-4 items-start">
                  <span className="text-red-500 shrink-0 mt-1">✕</span> People
                  looking for a cheap, generic, copy-paste workout PDF.
                </li>
                <li className="flex gap-4 items-start">
                  <span className="text-red-500 shrink-0 mt-1">✕</span> Those
                  who constantly complain and make excuses about their busy
                  schedules.
                </li>
                <li className="flex gap-4 items-start">
                  <span className="text-red-500 shrink-0 mt-1">✕</span> Anyone
                  expecting "magic pills" or overnight results without putting
                  in the required effort.
                </li>
              </ul>
            </div>

            <div className="bg-gradient-to-br from-zinc-950 to-amber-950/20 p-8 md:p-10 rounded-3xl border border-amber-500/30 shadow-[0_0_40px_rgba(245,158,11,0.1)]">
              <div className="flex items-center gap-4 mb-8">
                <div className="bg-amber-500/10 p-3 rounded-full text-amber-500">
                  <CheckCircle className="h-6 w-6 md:h-8 md:w-8" />
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-amber-400">
                  Who This IS For
                </h3>
              </div>
              <ul className="space-y-6 text-zinc-300 text-lg">
                <li className="flex gap-4 items-start">
                  <span className="text-amber-500 shrink-0 mt-1">✓</span>{" "}
                  High-achieving professionals (executives, founders, and
                  managers).
                </li>
                <li className="flex gap-4 items-start">
                  <span className="text-amber-500 shrink-0 mt-1">✓</span> People
                  who value their time and want a done-for-you strategic system
                  that fits their lifestyle.
                </li>
                <li className="flex gap-4 items-start">
                  <span className="text-amber-500 shrink-0 mt-1">✓</span>{" "}
                  Action-takers ready to invest in premium coaching for
                  guaranteed, sustainable results.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Programs Section */}
      <section
        id="programs"
        className="py-24 bg-black border-t border-zinc-900"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-bold mb-4">
              Structured For Success
            </h2>
            <p className="text-zinc-400 max-w-2xl mx-auto text-lg">
              No generic templates. Choose a dedicated path designed to get you
              specific, measurable results.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Package 1 */}
            <div className="bg-zinc-900 border border-zinc-800 rounded-3xl p-8 hover:border-zinc-600 transition-colors">
              <h3 className="text-2xl font-bold mb-2">Weight Loss Mastery</h3>
              <p className="text-zinc-400 mb-6 min-h-[48px]">
                Melt stubborn body fat without giving up your lifestyle or
                spending hours doing cardio.
              </p>
              <div className="mb-8">
                <span className="text-4xl font-extrabold">₦80k</span>
                <span className="text-zinc-500"> / month</span>
              </div>
              <ul className="space-y-4 mb-8">
                {[
                  "Custom Caloric Deficit Plan",
                  "3x/Week Strength Protocol",
                  "Weekly Progress Reviews",
                  "WhatsApp Support",
                ].map((feature, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <CheckCircle className="h-5 w-5 text-amber-500 shrink-0 mt-0.5" />
                    <span className="text-zinc-300">{feature}</span>
                  </li>
                ))}
              </ul>
              <a
                href="#booking"
                className="block text-center w-full bg-zinc-800 hover:bg-zinc-700 text-white py-3 rounded-xl font-bold transition-colors"
              >
                Apply Now
              </a>
            </div>

            {/* Package 2 - Premium/Online Coaching */}
            <div className="bg-gradient-to-b from-amber-500/10 to-zinc-900 border-2 border-amber-500 rounded-3xl p-8 relative transform md:-translate-y-4 shadow-[0_0_40px_rgba(245,158,11,0.15)]">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-amber-500 text-black px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider">
                Most Popular
              </div>
              <h3 className="text-2xl font-bold mb-2 text-amber-400">
                Elite Online Coaching
              </h3>
              <p className="text-zinc-400 mb-6 min-h-[48px]">
                The ultimate 90-day transformation experience for busy
                professionals anywhere in the world.
              </p>
              <div className="mb-8">
                <span className="text-4xl font-extrabold">₦150k</span>
                <span className="text-zinc-500"> / program</span>
              </div>
              <ul className="space-y-4 mb-8">
                {[
                  "Complete 90-Day Blueprint",
                  "Custom Meal & Macro Planning",
                  "Form Correction via Video",
                  "1-on-1 Bi-Weekly Strategy Calls",
                  "24/7 Priority Access to Me",
                  "Guaranteed Results System",
                ].map((feature, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <CheckCircle className="h-5 w-5 text-amber-500 shrink-0 mt-0.5" />
                    <span className="text-zinc-200">{feature}</span>
                  </li>
                ))}
              </ul>
              <a
                href="#booking"
                className="block text-center w-full bg-amber-500 hover:bg-amber-400 text-black py-4 rounded-xl font-bold text-lg transition-all shadow-lg hover:shadow-amber-500/25"
              >
                Secure Your Spot
              </a>
            </div>

            {/* Package 3 */}
            <div className="bg-zinc-900 border border-zinc-800 rounded-3xl p-8 hover:border-zinc-600 transition-colors">
              <h3 className="text-2xl font-bold mb-2">Muscle & Recomp</h3>
              <p className="text-zinc-400 mb-6 min-h-[48px]">
                Build lean mass, increase strength, and completely change your
                body composition.
              </p>
              <div className="mb-8">
                <span className="text-4xl font-extrabold">₦80k</span>
                <span className="text-zinc-500"> / month</span>
              </div>
              <ul className="space-y-4 mb-8">
                {[
                  "Hypertrophy Focused Programming",
                  "Surplus/Maintenance Dieting",
                  "Progressive Overload Tracking",
                  "Supplementation Guide",
                ].map((feature, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <CheckCircle className="h-5 w-5 text-amber-500 shrink-0 mt-0.5" />
                    <span className="text-zinc-300">{feature}</span>
                  </li>
                ))}
              </ul>
              <a
                href="#booking"
                className="block text-center w-full bg-zinc-800 hover:bg-zinc-700 text-white py-3 rounded-xl font-bold transition-colors"
              >
                Apply Now
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Brand Story Section */}
      <section id="story" className="py-24 bg-zinc-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div className="relative">
              {/* High-quality portrait of Tunde */}
              <div className="aspect-[4/5] rounded-3xl overflow-hidden relative border border-zinc-800">
                <img
                  src="https://i.ibb.co/ynfNYLsZ/tunde-portrait-1.jpg"
                  alt="Tunde Adeyemi - Fitness Coach"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent"></div>
                <div className="absolute bottom-8 left-8">
                  <h3 className="text-3xl font-bold text-white">
                    Tunde Adeyemi
                  </h3>
                  <p className="text-amber-500 font-medium">
                    Head Coach & Founder
                  </p>
                </div>
              </div>

              {/* Floating Badge */}
              <div className="absolute -bottom-6 -right-6 bg-zinc-900 border border-zinc-700 p-6 rounded-2xl shadow-xl max-w-xs hidden md:block">
                <div className="flex items-center gap-4 mb-2">
                  <div className="bg-amber-500/20 p-3 rounded-full text-amber-500">
                    <TrendingDown className="h-6 w-6" />
                  </div>
                  <div>
                    <div className="text-2xl font-bold">5+ Years</div>
                    <div className="text-xs text-zinc-400 uppercase tracking-wide">
                      Transforming Lives
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6">
                I used to be "just another trainer." <br />
                <span className="text-zinc-500">
                  Then I realized the truth.
                </span>
              </h2>
              <div className="space-y-6 text-lg text-zinc-400 leading-relaxed">
                <p>
                  For years, I worked the gym floor in Lagos. I saw executives,
                  business owners, and busy professionals coming in day after
                  day, sweating for hours, and looking exactly the same 6 months
                  later.
                </p>
                <p>
                  Why? Because 1-hour sessions don't change your body.{" "}
                  <strong className="text-zinc-200">
                    Systems and accountability change your body.
                  </strong>
                </p>
                <p>
                  That's why I stopped doing random personal training sessions.
                  I designed a premium, structured system that focuses on the
                  other 23 hours of your day. It’s built specifically for people
                  who don't have time to waste and just want a proven roadmap to
                  lose 10-20kg and reclaim their confidence.
                </p>
                <p className="text-white font-medium border-l-4 border-amber-500 pl-4 italic">
                  "My goal isn't just to make you sweat. It's to fundamentally
                  upgrade your health, your physique, and how you show up in
                  your career."
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section className="py-24 bg-zinc-900/30 border-t border-zinc-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-bold mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-zinc-400 text-lg">
              Everything you need to know about my coaching process.
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                className={`bg-zinc-900 border ${
                  openFaq === idx ? "border-amber-500/50" : "border-zinc-800"
                } rounded-2xl overflow-hidden transition-colors duration-300`}
              >
                <button
                  onClick={() => setOpenFaq(openFaq === idx ? -1 : idx)}
                  className="w-full flex justify-between items-center p-6 md:p-8 text-left focus:outline-none"
                >
                  <span className="font-bold text-lg md:text-xl pr-8 text-zinc-100">
                    {faq.q}
                  </span>
                  <span
                    className={`shrink-0 p-2 rounded-full transition-colors ${
                      openFaq === idx
                        ? "bg-amber-500 text-black"
                        : "bg-zinc-800 text-amber-500"
                    }`}
                  >
                    {openFaq === idx ? (
                      <Minus className="h-5 w-5" />
                    ) : (
                      <Plus className="h-5 w-5" />
                    )}
                  </span>
                </button>
                <div
                  className={`px-6 md:px-8 overflow-hidden transition-all duration-300 ease-in-out ${
                    openFaq === idx
                      ? "max-h-96 pb-6 md:pb-8 opacity-100"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <p className="text-zinc-400 text-lg leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Booking System Section */}
      <section
        id="booking"
        className="py-24 bg-black border-t border-zinc-900 relative overflow-hidden"
      >
        {/* Abstract Background Element */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber-500/5 rounded-full blur-[120px] pointer-events-none"></div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="bg-zinc-900 border border-zinc-800 rounded-3xl p-8 md:p-12 shadow-2xl">
            <div className="text-center mb-10">
              <span className="inline-block bg-amber-500/10 text-amber-500 font-semibold px-4 py-1.5 rounded-full text-sm mb-4">
                Limited Availability
              </span>
              <h2 className="text-3xl md:text-5xl font-bold mb-4">
                Book Your Strategy Call
              </h2>
              <p className="text-zinc-400 text-lg">
                Let's map out exactly how you'll lose your first 5kg in the next
                30 days. <br className="hidden md:block" />
                This paid consultation (₦15,000) ensures I only speak with
                serious professionals ready to commit.
              </p>
            </div>

            <div className="bg-black rounded-2xl border border-zinc-800 p-6 md:p-8">
              <div className="flex flex-col md:flex-row gap-8">
                {/* Left Side: Call Details */}
                <div className="md:w-1/3 border-b md:border-b-0 md:border-r border-zinc-800 pb-8 md:pb-0 md:pr-8">
                  <h3 className="font-bold text-xl mb-6">
                    Discovery & Strategy Session
                  </h3>
                  <div className="space-y-4 text-zinc-400 text-sm">
                    <div className="flex items-center gap-3">
                      <Clock className="h-5 w-5 text-zinc-500" />
                      <span>45 Minutes</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <Calendar className="h-5 w-5 text-zinc-500" />
                      <span>Google Meet / Zoom</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <span className="font-bold text-amber-500 text-lg">
                        ₦15,000
                      </span>
                      <span>Consultation Fee</span>
                    </div>
                  </div>
                </div>

                {/* Right Side: Action */}
                <div className="md:w-2/3 flex flex-col justify-center items-center text-center">
                  <div className="mb-6">
                    <Calendar className="h-16 w-16 text-zinc-700 mx-auto mb-4" />
                    <h4 className="text-lg font-medium text-zinc-300">
                      Select a Date & Time
                    </h4>
                    <p className="text-sm text-zinc-500 mt-2">
                      You will be redirected to my secure scheduling and payment
                      gateway.
                    </p>
                  </div>

                  <a
                    href="https://paystack.com/buy/book-consultation-orzpqk"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full sm:w-auto bg-amber-500 text-black px-8 py-4 rounded-xl font-bold text-lg hover:bg-amber-400 transition-all transform hover:-translate-y-1 shadow-lg shadow-amber-500/20 flex items-center justify-center gap-2"
                  >
                    Proceed to Schedule <ArrowRight className="h-5 w-5" />
                  </a>
                  <p className="text-xs text-zinc-600 mt-4">
                    Secure payment via Paystack
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-zinc-950 py-12 border-t border-zinc-900 text-center md:text-left">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-2">
            <Dumbbell className="h-6 w-6 text-amber-500" />
            <span className="font-bold text-xl uppercase tracking-tighter">
              Coach Tunde
            </span>
          </div>

          <div className="text-zinc-500 text-sm">
            © {new Date().getFullYear()} Tunde Adeyemi. All rights reserved.
            Built for high performers.
          </div>

          <div className="flex gap-6">
            <a
              href="#"
              className="text-zinc-500 hover:text-amber-500 transition-colors"
            >
              Instagram
            </a>
            <a
              href="#"
              className="text-zinc-500 hover:text-amber-500 transition-colors"
            >
              Twitter
            </a>
            <a
              href="#"
              className="text-zinc-500 hover:text-amber-500 transition-colors"
            >
              Contact
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
